import shopifyGenericDefaults from '../shopify-generic/config.js';
import {
  ConvermaxModalOpener,
  ConvermaxProductForm,
  ConvermaxQuantityInput,
  ConvermaxQuickAddModal,
} from './modalDialog.js';

const { baseFields } = shopifyGenericDefaults.fitmentSearch;
const ignoreFields = shopifyGenericDefaults.Widgets.find((w) => w.name === 'Facets')?.ignoreFields;

const isB2B = !!window.Convermax?.Shopify?.getCompanyId();
window.Convermax.isB2B = isB2B;

const baseUpdateCallback = shopifyGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchResult',
)?.updateCallback;

function updateCallback() {
  baseUpdateCallback?.();
  try {
    window._swat.initializeActionButtons('.cmRepeater_items');
  } catch {
    setTimeout(() => window._swat?.initializeActionButtons('.cmRepeater_items'), 1000);
  }
}

window.Convermax.isCurrentVehicle = (vehicle, currentVehicle) =>
  vehicle.Type === currentVehicle.Type &&
  vehicle.Make === currentVehicle.Make &&
  vehicle.Model === currentVehicle.Model;

function replaceOldestVehicleInGarage(vehicle) {
  const garageItems = window.Convermax.getVehicleList();

  if (garageItems.length >= 5 && !window.Convermax.isCurrentVehicle(vehicle, garageItems[0])) {
    window.Convermax.removeVehicle(garageItems[0]);
  }
}

const InitFunc = () => {
  shopifyGenericDefaults.InitFunc?.();
  customElements.define('convermax-modal-opener', ConvermaxModalOpener);
  customElements.define('convermax-quick-add-modal', ConvermaxQuickAddModal);
  customElements.define('convermax-product-form', ConvermaxProductForm);
  customElements.define('convermax-quantity-input', ConvermaxQuantityInput);
};

const AfterInit = () => {
  shopifyGenericDefaults.AfterInit?.();

  if (document.querySelector('#cm-collection-page, #cm_results')) {
    const scrollButtonEl = document.getElementById('cm_ScrollButton');
    if (!scrollButtonEl) {
      return;
    }

    const toggleScrollButton = () => {
      const searchPageEl = document.querySelector('.cm_SearchPage');
      const facetPanelEl = document.querySelector('.cm_FacetPanel');

      if (!searchPageEl || !facetPanelEl) {
        return;
      }

      const scrolled = window.scrollY;
      const viewportHeight = window.innerHeight;

      const facetRect = facetPanelEl.getBoundingClientRect();
      const spaceBelowFacet = viewportHeight - facetRect.bottom;

      const searchPageRect = searchPageEl.getBoundingClientRect();
      const isSearchPageBottomVisible = searchPageRect.bottom + 100 <= viewportHeight;

      const shouldShow =
        scrolled > viewportHeight && spaceBelowFacet >= viewportHeight - 200 && !isSearchPageBottomVisible;

      scrollButtonEl.classList.toggle('cm_hide', !shouldShow);
    };

    window.addEventListener('scroll', toggleScrollButton);
    window.addEventListener('resize', toggleScrollButton);

    toggleScrollButton();
  }
};

function showBoughtTogetherItems() {
  const boughtTogetherSection = window.document.querySelector('.section-bought-together');

  if (boughtTogetherSection) {
    boughtTogetherSection.style = 'display: block;';
  }
}

function onVerifyFitmentResponseReceived(response) {
  const fitmentTable = window.document.querySelector('#cm-fitment-table');
  if (fitmentTable) {
    const item = response?.Items?.[0];
    const fits = item?.fitsTheVehicle;

    if (fits && fits === 'unknown') {
      fitmentTable.parentElement?.parentElement?.classList.add('cm_hide');
      return;
    }
  }
}

function responseHandler(response) {
  const pageType = window.Convermax.Shopify.getPageType();

  if (pageType === 'collection' || pageType === 'vendors') {
    const { selection, query, sort, pageSize, pageNumber, filterQuery } = window.Convermax.getSearchRequest();
    const isVehicleSelected = window.Convermax.isVehicleSelected();

    if (
      isVehicleSelected ||
      filterQuery ||
      selection.length > 0 ||
      query.length > 0 ||
      pageNumber > 0 ||
      pageSize < (isB2B ? 32 : 110) ||
      sort !== 'relevance' ||
      window.document.querySelector('.cmTemplate_timeout') ||
      window.document.querySelector('.cmTemplate_networkError')
    ) {
      window.document.body.classList.add('cm_hideDefaultResults');
    }
  }

  return response;
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  responseHandler,
  AfterInit,
  infiniteScrollEnabled: false,
  pagination: {
    centralRange: window.innerWidth <= 1024 ? 1 : 2,
    edgeRange: 1,
  },
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    pageSize: isB2B ? 32 : 110,
  },
  autocomplete: {
    ...shopifyGenericDefaults.autocomplete,
    order: ['facetValue', 'text', 'product'],
    pageSize: isB2B ? 32 : 108, //show x3 page size by default
  },
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    onVehicleSelected: (vehicle) => {
      replaceOldestVehicleInGarage(vehicle);
    },
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
  },
  product: {
    ...shopifyGenericDefaults.product,
    dropdownImageWidth: 200,
    dropdownImageHeight: 200,
    noImageSrc: 'https://motoscoot-test.myconvermax.com/static/images/nopic_ms.png',
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchResult',
          'SearchVehicleWidget',
          'VehicleWidgetDialog',
          'CategoryPage',
          'BoughtTogether',
          'Facets',
          'FacetBrandTiles',
        ].includes(w.name),
    ),
    {
      name: 'FilterSearchBox',
      visibleIf: () => window.location.pathname !== window.Convermax.Shopify.getSearchPageUrl(),
    },
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      instantInfiniteScroll: !!window.Convermax.config?.instantInfiniteScroll,
      updateCallback,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
      visibleIf: () => !document.querySelector('#cm-brand-list'),
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { insertBefore: 'body.template--collection #ProductGridContainer', class: 'cm_main-content' },
      template: 'MainContent',
    },
    {
      name: 'CategoryFacetPanelContainer',
      type: 'SearchPage',
      location: { replace: 'body.template--collection .facets-container' },
      template: 'FacetPanelContainer',
    },
    {
      name: 'CategoryPagination',
      type: 'SearchPage',
      location: {
        replace: 'body.template--collection .pagination-wrapper',
      },
      template: 'CategoryPagination',
    },
    {
      name: 'SearchVehicleWidget_collections',
      type: 'VehicleWidget',
      location: '#cm-collection-ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 650,
      isAlwaysActive: false,
      initCollapsed: false,
    },
    {
      name: 'BoughtTogether',
      type: 'BuyItemsTogether',
      location: '#cm-bought-together-products',
      template: 'product/boughtTogether',
      mode: 'BoughtTogether',
      count: 3,
      onItemsRendered: () => showBoughtTogetherItems(),
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      isVehicleWidgetDisabled: true,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'VehicleWidgetDialog'),
      location: {
        id: 'cm_GarageDialog',
        class: 'GarageDialog VerifyDialog',
      },
      doNotRedirectOnVehicleSelect: window.Convermax.Shopify?.getPageType() === 'product',
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
    },
    {
      name: 'ScrollButton',
      type: 'DialogButton',
      location: {
        wrapper: 'button',
        lastChildOf: 'body',
        class: 'cm_hide',
      },
      onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
      template: 'main/scrollButton',
    },
  ],
};
